import React, { useState, useEffect } from 'react'
import { components } from 'cng-web-lib'
import { Box, Grid, Paper, Typography, Button } from '@material-ui/core'
import {FirmCodesAutocompleteField} from 'src/components/na'
import  MassUpdatePTTMakeValidationSchema  from 'src/views/aceocean/permittotransfer/MassUpdatePTTMakeValidationSchema'
import { useWatch } from 'react-hook-form'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
  CngDialog
} = components

const DEFAULT_INITIAL_VALUES = {
  firmsCode: '',
  bondedCarrierType: '',
  bondedCarrier: '',
}

const validationSchema = MassUpdatePTTMakeValidationSchema();
 export default function MassUpdatePTTDialog(props) {
  const { open, onClose, onSave, selectedBills, translatedTextsObject, disabled, shouldHideMap,portOfDischarge } = props

  const [formValues, setFormValues] = useState(DEFAULT_INITIAL_VALUES)
  const [errors, setErrors] = useState({})

  const firmsCode = useWatch({ name: 'firmsCode' })
  
  useEffect(() => {
    if (open) {
      setFormValues(DEFAULT_INITIAL_VALUES)
      setErrors({})
    }
  }, [open])

  const handleChange = (name, value) => {
    setFormValues(prev => ({
      ...prev,
      [name]: value || '', 
    }))

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: undefined,
    }))
  }


  const handleSave = () => {
    validationSchema.validate(formValues, { abortEarly: false })
      .then(() => {
        setErrors({})
        const updatedBills = selectedBills.map((bill) => {
          const result = {
            _id: bill._id,
          }

    if (formValues.firmsCode?.trim()) {
      result.firmsCode = formValues.firmsCode;
    }
    if (formValues.bondedCarrierType?.trim()) {
      result.bondedCarrierType = formValues.bondedCarrierType;
    }
    if (formValues.bondedCarrier?.trim()) {
      result.bondedCarrier = formValues.bondedCarrier;
    }

    return result;
  });

        onSave(updatedBills)
      })
      .catch((validationErrors) => {
        const formattedErrors = {}
        validationErrors.inner.forEach(err => {
          formattedErrors[err.path] = err.message
        })
        setErrors(formattedErrors)
      })
  }

  return (
    <CngDialog
      dialogTitle={translatedTextsObject.massUpdateTitle || 'Mass Update Fields'}
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      dialogContent={
        <Box p={2}>
          <Paper variant="outlined" style={{ padding: 16 }}>
            <Grid container spacing={2}>

              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.firmsCode}>
                <FirmCodesAutocompleteField
                  name="firmsCode"
                  label={translatedTextsObject.firmsCode}
                  disabled={disabled}
                  size="small"
                  value={formValues.firmsCode}
                  onChange={(e, val) => handleChange('firmsCode', val ? val.value : '')}
                  error={!!errors.firmsCode}
                  helperText={errors.firmsCode}
                  key={firmsCode+portOfDischarge}
                  portCode={portOfDischarge}
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.bondedCarrierType}>
                <CngCodeMasterAutocompleteField
                  name="bondedCarrierType"
                  label={translatedTextsObject.bondedCarrierType}
                  disabled={disabled}
                  size="small"
                  codeType="ACEOCN_PTT_BONDED_CARRIER_TYPE"
                  value={formValues.bondedCarrierType}
                  onChange={(e, val) => handleChange('bondedCarrierType', val ? val.value : '')}
                  error={!!errors.bondedCarrierType}
                  helperText={errors.bondedCarrierType}
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.bondedCarrier}>
                <CngTextField
                  name="bondedCarrier"
                  label={translatedTextsObject.bondedCarrier}
                  disabled={disabled}
                  size="small"
                  value={formValues.bondedCarrier}
                  onChange={(e) => handleChange('bondedCarrier', e.target.value)}
                  error={!!errors.bondedCarrier}
                  helperText={errors.bondedCarrier}
                />
              </CngGridItem>

              <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
                <Grid item>
                  <Button variant="outlined" color="secondary" onClick={onClose}>
                    {translatedTextsObject.cancel || 'Cancel'}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary" onClick={handleSave}>
                    {translatedTextsObject.save || 'Save'}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      }
    />
  )
}
